document.addEventListener('DOMContentLoaded', () => {
  const configNode = document.getElementById('sb-gift-wrap-config');
  const template = document.getElementById('sb-gift-wrap-template');
  if (!configNode || !template) return;
  const config = JSON.parse(configNode.textContent);
  const root = config.root.endsWith('/') ? config.root : config.root + '/';
  let selected = config.selected === 'Yes';
  let busy = false;
  let status = '';
  let sequence = 0;
  const sync = () => {
    document.querySelectorAll('[data-sb-gift-wrap-input]').forEach(input => {
      input.checked = selected;
      input.disabled = busy;
    });
    document.querySelectorAll('[data-sb-gift-wrap-status]').forEach(node => {
      if (node.textContent !== status) node.textContent = status;
    });
    document.querySelectorAll('[data-sb-gift-wrap]').forEach(node => node.setAttribute('aria-busy', String(busy)));
  };
  const refresh = async () => {
    const current = ++sequence;
    try {
      const response = await fetch(root + 'cart.js', {headers: {Accept: 'application/json'}});
      if (!response.ok) return;
      const cart = await response.json();
      if (current !== sequence || busy) return;
      selected = cart.attributes?.['Gift wrapping'] === 'Yes';
      document.querySelectorAll('[data-sb-gift-wrap]').forEach(node => { node.hidden = !cart.requires_shipping; });
      sync();
    } catch (_) {}
  };
  const insert = () => {
    const form = document.querySelector('#cart-info form');
    if (!form || form.querySelector('[data-sb-gift-wrap]')) return;
    const checkout = form.querySelector('[name="checkout"], .checkout-button, a[href*="/checkout"]');
    const fragment = template.content.cloneNode(true);
    if (checkout) checkout.before(fragment);
    else form.append(fragment);
    sync();
    refresh();
  };
  insert();
  refresh();
  const drawer = document.getElementById('cart-info');
  if (drawer) new MutationObserver(insert).observe(drawer, {childList: true, subtree: true});
  document.addEventListener('change', async event => {
    if (!event.target.matches('[data-sb-gift-wrap-input]')) return;
    const previous = selected;
    selected = event.target.checked;
    sequence++;
    busy = true;
    status = config.saving;
    sync();
    try {
      const response = await fetch(root + 'cart/update.js', {
        method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({attributes: {'Gift wrapping': selected ? 'Yes' : 'No'}})
      });
      if (!response.ok) throw new Error('Gift wrap save failed');
      const cart = await response.json();
      if ((cart.attributes?.['Gift wrapping'] === 'Yes') !== selected) throw new Error('Gift wrap not saved');
      status = config.saved;
    } catch (_) {
      selected = previous;
      status = config.error;
    } finally {
      busy = false;
      sync();
    }
  });
  const guard = event => {
    if (!busy) return;
    const checkout = event.type === 'submit' ? event.target.closest('form[action*="/cart"]') : event.target.closest('[name="checkout"], .checkout-button, a[href*="/checkout"], .additional-checkout-buttons');
    if (checkout) {
      event.preventDefault();
      event.stopImmediatePropagation();
      status = config.saving;
      sync();
    }
  };
  document.addEventListener('click', guard, true);
  document.addEventListener('submit', guard, true);
});
